import React from 'react';
import { Link } from 'react-router-dom';

function InvestmentDisclaimer() {
  return (
    <div className="public-page">
      {/* Navigation - Premium Compact Header */}
      <nav className="public-nav">
        <div className="public-nav-container">
          <Link to="/" className="public-nav-brand">
            <img 
              src="/assets/black_peak_analytics_logo_transparent_240.png" 
              alt="Black Peak Analytics" 
              className="nav-brand-logo" 
            />
          </Link>
          <div className="public-nav-links">
            <Link to="/" className="public-nav-link">Home</Link>
            <Link to="/pricing" className="public-nav-link">Pricing</Link>
            <Link to="/login" className="public-nav-link">Log in</Link>
          </div>
        </div>
      </nav>

      {/* Page Content */}
      <div className="investment-disclaimer-content" style={{
        backgroundImage: 'radial-gradient(ellipse at 50% 20%, rgba(16, 185, 129, 0.08) 0%, transparent 50%), radial-gradient(ellipse at 80% 60%, rgba(245, 158, 11, 0.06) 0%, transparent 50%)',
        minHeight: '100vh',
        padding: '4rem 0'
      }}>
        <div style={{
          maxWidth: '56rem',
          margin: '0 auto',
          padding: '0 2rem'
        }}>
          {/* Hero Section */}
          <div style={{
            marginBottom: '3.5rem',
            paddingBottom: '2rem',
            borderBottom: '1px solid rgba(71, 85, 105, 0.4)'
          }}>
            <p className="investment-disclaimer-eyebrow" style={{
              fontWeight: '700',
              letterSpacing: '0.15em',
              textTransform: 'uppercase',
              margin: '0 0 1rem 0',
              textAlign: 'left'
            }}>
              Legal Notice
            </p>
            <h1 style={{
              fontWeight: '700',
              fontFamily: 'Georgia, "Times New Roman", serif',
              letterSpacing: '-0.02em',
              margin: '0 0 1rem 0',
              textAlign: 'left',
              lineHeight: '1.1'
            }}>
              Investment Disclaimer
            </h1>
            <p className="investment-disclaimer-subtitle" style={{
              margin: '0',
              textAlign: 'left',
              lineHeight: '1.6'
            }}>
              Important information about using Black Peak Analytics
            </p>
          </div>

          {/* Not Financial Advice */}
          <div className="investment-disclaimer-card investment-disclaimer-card-accent" style={{
            borderRadius: '0.5rem',
            padding: '2rem',
            marginBottom: '2rem',
            boxShadow: '0 0.25rem 1rem rgba(0, 0, 0, 0.2)',
            textAlign: 'left'
          }}>
            <h2 style={{
              fontWeight: '700',
              fontFamily: 'Georgia, "Times New Roman", serif',
              margin: '0 0 1.25rem 0',
              paddingBottom: '0.75rem',
              borderBottom: '2px solid rgba(16, 185, 129, 0.3)',
              textAlign: 'left'
            }}>
              Not Financial Advice
            </h2>
            <p style={{
              lineHeight: '1.75',
              margin: '0 0 1rem 0',
              textAlign: 'left'
            }}>
              Black Peak Analytics is an independent investment research and stock-screening tool. We are not a financial advisor, broker, investment adviser, or registered investment company. The Investment Scores, rankings, scans, reports, alerts, validation tools, and all other content provided through our platform are for informational and educational research purposes only.
            </p>
            <p style={{
              lineHeight: '1.75',
              margin: '0',
              textAlign: 'left'
            }}>
              Nothing on this platform constitutes personalized investment advice or a recommendation to buy, sell, or hold any security. We do not provide individualized recommendations tailored to your specific financial situation, investment objectives, or risk tolerance.
            </p>
          </div>

          {/* User Responsibility */}
          <div className="investment-disclaimer-card investment-disclaimer-card-warning" style={{
            borderRadius: '0.5rem',
            padding: '2rem',
            marginBottom: '2rem',
            boxShadow: '0 0.25rem 1rem rgba(0, 0, 0, 0.2)',
            textAlign: 'left'
          }}>
            <h2 style={{
              fontWeight: '700',
              fontFamily: 'Georgia, "Times New Roman", serif',
              margin: '0 0 1.25rem 0',
              paddingBottom: '0.75rem',
              borderBottom: '2px solid rgba(245, 158, 11, 0.3)',
              textAlign: 'left'
            }}>
              Your Responsibility
            </h2>
            <p style={{
              lineHeight: '1.75',
              margin: '0 0 1rem 0',
              textAlign: 'left'
            }}>
              You are solely responsible for your own investment decisions. Before making any investment, you should conduct your own research, perform your own analysis, and consult with qualified financial, legal, and tax professionals as appropriate for your individual circumstances.
            </p>
            <p style={{
              lineHeight: '1.75',
              margin: '0',
              textAlign: 'left'
            }}>
              All investments involve risk, including the potential loss of principal. You should never invest money you cannot afford to lose. Past performance does not guarantee future results.
            </p>
          </div>

          {/* No Guarantee of Results */}
          <div className="investment-disclaimer-card investment-disclaimer-card-accent" style={{
            borderRadius: '0.5rem',
            padding: '2rem',
            marginBottom: '2rem',
            boxShadow: '0 0.25rem 1rem rgba(0, 0, 0, 0.2)',
            textAlign: 'left'
          }}>
            <h2 style={{
              fontWeight: '700',
              fontFamily: 'Georgia, "Times New Roman", serif',
              margin: '0 0 1.25rem 0',
              paddingBottom: '0.75rem',
              borderBottom: '2px solid rgba(16, 185, 129, 0.3)',
              textAlign: 'left'
            }}>
              No Guarantee of Results
            </h2>
            <p style={{
              lineHeight: '1.75',
              margin: '0 0 1rem 0',
              textAlign: 'left'
            }}>
              We make no guarantees, representations, or warranties regarding the accuracy, completeness, or timeliness of any information, data, scores, rankings, or analysis provided through Black Peak Analytics. Investment Scores and rankings are based on quantitative models and historical data, which may not accurately predict future performance.
            </p>
            <p style={{
              lineHeight: '1.75',
              margin: '0',
              textAlign: 'left'
            }}>
              Market conditions, company fundamentals, economic factors, and countless other variables can change rapidly and unpredictably. No model, score, or ranking system can account for all possible future scenarios or guarantee profitable investment outcomes.
            </p>
          </div>

          {/* Historical Performance Limitations */}
          <div className="investment-disclaimer-card investment-disclaimer-card-warning" style={{
            borderRadius: '0.5rem',
            padding: '2rem',
            marginBottom: '2rem',
            boxShadow: '0 0.25rem 1rem rgba(0, 0, 0, 0.2)',
            textAlign: 'left'
          }}>
            <h2 style={{
              fontWeight: '700',
              fontFamily: 'Georgia, "Times New Roman", serif',
              margin: '0 0 1.25rem 0',
              paddingBottom: '0.75rem',
              borderBottom: '2px solid rgba(245, 158, 11, 0.3)',
              textAlign: 'left'
            }}>
              Historical Performance Limitations
            </h2>
            <p style={{
              lineHeight: '1.75',
              margin: '0 0 1rem 0',
              textAlign: 'left'
            }}>
              Historical backtesting results, Strategy Lab data, and past performance metrics shown on our platform are based on historical data and simulated strategies. These results do not represent actual trading and do not account for real-world factors such as transaction costs, slippage, taxes, market impact, or the practical challenges of executing trades.
            </p>
            <p style={{
              lineHeight: '1.75',
              margin: '0',
              textAlign: 'left'
            }}>
              Past performance is not indicative of future results. Historical data may not reflect future market conditions, and strategies that performed well historically may not perform well in the future.
            </p>
          </div>

          {/* Data and Model Limitations */}
          <div className="investment-disclaimer-card investment-disclaimer-card-accent" style={{
            borderRadius: '0.5rem',
            padding: '2rem',
            marginBottom: '2rem',
            boxShadow: '0 0.25rem 1rem rgba(0, 0, 0, 0.2)',
            textAlign: 'left'
          }}>
            <h2 style={{
              fontWeight: '700',
              fontFamily: 'Georgia, "Times New Roman", serif',
              margin: '0 0 1.25rem 0',
              paddingBottom: '0.75rem',
              borderBottom: '2px solid rgba(16, 185, 129, 0.3)',
              textAlign: 'left'
            }}>
              Data and Model Limitations
            </h2>
            <p style={{
              lineHeight: '1.75',
              margin: '0 0 1rem 0',
              textAlign: 'left'
            }}>
              Our Investment Scores and rankings are generated using quantitative models based on publicly available financial data. While we strive to use reliable data sources, we cannot guarantee the accuracy or completeness of third-party data. Data may contain errors, omissions, or delays.
            </p>
            <p style={{
              lineHeight: '1.75',
              margin: '0',
              textAlign: 'left'
            }}>
              Our models are based on specific assumptions and methodologies that may not be suitable for all investors or market conditions. Model outputs should be considered as one of many factors in your investment research process, not as the sole basis for investment decisions.
            </p>
          </div>

          {/* Portfolio Alerts and Reports */}
          <div className="investment-disclaimer-card investment-disclaimer-card-warning" style={{
            borderRadius: '0.5rem',
            padding: '2rem',
            marginBottom: '2rem',
            boxShadow: '0 0.25rem 1rem rgba(0, 0, 0, 0.2)',
            textAlign: 'left'
          }}>
            <h2 style={{
              fontWeight: '700',
              fontFamily: 'Georgia, "Times New Roman", serif',
              margin: '0 0 1.25rem 0',
              paddingBottom: '0.75rem',
              borderBottom: '2px solid rgba(245, 158, 11, 0.3)',
              textAlign: 'left'
            }}>
              Portfolio Alerts and Reports
            </h2>
            <p style={{
              lineHeight: '1.75',
              margin: '0 0 1rem 0',
              textAlign: 'left'
            }}>
              Portfolio alerts, notifications, and PDF reports are automated tools designed to help you monitor your holdings based on your preferences. These alerts are not recommendations to buy, sell, or hold any security. They are informational notifications based on quantitative criteria you have selected.
            </p>
            <p style={{
              lineHeight: '1.75',
              margin: '0',
              textAlign: 'left'
            }}>
              You should independently evaluate any alert or notification before taking action. Alerts may be triggered by temporary market fluctuations, data anomalies, or model limitations that do not reflect the true investment merit of a security.
            </p>
          </div>

          {/* Consult a Professional */}
          <div className="investment-disclaimer-card investment-disclaimer-card-accent" style={{
            borderRadius: '0.5rem',
            padding: '2rem',
            marginBottom: '2rem',
            boxShadow: '0 0.25rem 1rem rgba(0, 0, 0, 0.2)',
            textAlign: 'left'
          }}>
            <h2 style={{
              fontWeight: '700',
              fontFamily: 'Georgia, "Times New Roman", serif',
              margin: '0 0 1.25rem 0',
              paddingBottom: '0.75rem',
              borderBottom: '2px solid rgba(16, 185, 129, 0.3)',
              textAlign: 'left'
            }}>
              Consult a Qualified Professional
            </h2>
            <p style={{
              lineHeight: '1.75',
              margin: '0 0 1rem 0',
              textAlign: 'left'
            }}>
              Before making any investment decision, we strongly recommend consulting with a qualified financial advisor, investment professional, tax advisor, or attorney who can provide personalized advice based on your individual financial situation, goals, and risk tolerance.
            </p>
            <p style={{
              lineHeight: '1.75',
              margin: '0',
              textAlign: 'left'
            }}>
              Black Peak Analytics is a research tool to support your own due diligence and analysis. It is not a substitute for professional financial advice tailored to your specific circumstances.
            </p>
          </div>

          {/* Final Notice */}
          <div className="investment-disclaimer-final-notice" style={{
            borderRadius: '0.5rem',
            padding: '1.5rem',
            marginBottom: '3rem',
            textAlign: 'left'
          }}>
            <p style={{
              lineHeight: '1.7',
              margin: '0',
              textAlign: 'left',
              fontWeight: '500'
            }}>
              <strong>By using Black Peak Analytics, you acknowledge that you have read, understood, and agree to this disclaimer.</strong> You accept full responsibility for your investment decisions and understand that Black Peak Analytics and its operators are not liable for any losses or damages resulting from your use of this platform or reliance on any information provided herein.
            </p>
          </div>

        </div>
      </div>

      {/* Footer - compact target-style footer */}
      <footer className="public-footer public-footer-compact">
        <div className="public-footer-container public-footer-container-compact">
          <Link to="/" className="footer-brand-compact">
            <img 
              src="/assets/black_peak_analytics_logo_transparent_240.png" 
              alt="Black Peak Analytics" 
              className="footer-brand-logo" 
            />
          </Link>
          <nav className="footer-nav-compact" aria-label="Footer navigation">
            <Link to="/pricing" className="public-footer-link">Pricing</Link>
            <Link to="/support" className="public-footer-link">Support</Link>
            <Link to="/privacy" className="public-footer-link">Privacy</Link>
            <Link to="/terms" className="public-footer-link">Terms</Link>
            <Link to="/investment-disclaimer" className="public-footer-link">Disclaimer</Link>
          </nav>
          <p className="footer-disclaimer footer-disclaimer-compact">Independent research tool. Not financial advice.</p>
        </div>
      </footer>
    </div>
  );
}

export default InvestmentDisclaimer;
